import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import Upload from "./Common/CommonUpload/upload/Upload"
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import { alpha, makeStyles } from '@material-ui/core/styles';
import ScheduleDataAccess from '../services/scheduleDataAccess';
import PubSub from 'pubsub-js';
import Auth from '../services/auth';
import _ from 'lodash';
import ScheduleDetails from './ScheduleDetails';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { getDateOffset } from '../services/accountSettings';
import Snackbar from '@material-ui/core/Snackbar';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Link, useHistory } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import ReportDataAccess from '../services/reportDataAccess';
import UserDataAccess from '../services/userDataAccess';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import PatientSearch from './PatientSearch';
import WorkTypeSelector from './WorkTypeSelector';
import SingleUploader from './Common/CommonUpload/upload/SingleUploader';
import { LinearProgress } from '@material-ui/core';
import BatchCodingUploadsTable from './BatchCodingUploadTable';
import { checkRedXForJob } from '../services/transcriptionService';
import { savesScheduleEntry } from './expressScheduleEntry';
const dataAccess = new ReportDataAccess();
const searchAccess = new ScheduleDataAccess();
const userDataAccess = new UserDataAccess();
const auth = new Auth();

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    paperReports: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        height: '100%',
        width: '100%'
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    textField: {
        maxWidth: 155,
    },
    dateWrapper: {
        display: 'inline-block'
    },
    dateContainer: {
        paddingBottom: '4px',
    },
    root: {
        width: '100%',
        height: '500px'
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    errorText: {
        color: '#EF4444',
    },
}));
    const getSteps = () => {
        return ['Add Patient', 'Upload Op Report', 'Complete'];
    }
const defaultFromDate = {
    date: moment().subtract(30, 'days'),
    input: moment().subtract(30, 'days').format("MM/DD/YYYY")
};

const defaultToDate = {
    date: moment(),
    input: moment().format("MM/DD/YYYY")
};

let currentDate = new Date();

const defaultAppointment = {
    Id: 0,
    Account: auth.getActiveAccount(),
    AppointmentId: "",
    DateOfBirth: new Date().toJSON().slice(0, 10),
    DateOfService: new Date(currentDate.getTime() - (currentDate.getTimezoneOffset() * 60000)).toJSON().slice(0, 19),
    DictatorId: "",
    OperatingRoom: "",
    PatientFirstName: "",
    PatientId: "",
    CaseId: "",
    PatientLastName: "",
    PrimaryPhysican: "",
    PrimaryPhysicanNpi: "",
    Procedure: "",
    ProcedureId: "",
    ReferringPhysician: "",
    ReferringPhysicianNpi: "",
    Reports: []
}

const DocumentUpload = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState();
    const [searchResults, setSearchResult] = useState([]);
    const [ScheduleDetailDialogSettings, setScheduleDetailDialogSettings] = useState({ account: null, id: null, open: false });
    const [AddScheduleItemDialogSettings, setAddScheduleItemDialogSettings] = useState({ account: null, id: null, open: false });
    const [fromDate, setFromDate] = useState(defaultFromDate);
    const [toDate, setToDate] = useState(defaultToDate);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState(null);
    const [fileObject, setfileObject] = useState({ fileName: "" });
    const [availableDictators, setAvailableDictators] = useState([]);
    const [formValid, setFormValid] = useState(false);
    const [reportId, setReportId] = useState(0);
    const [showErrors, setShowErrors] = useState(false);
    const [fieldValid, setFieldValid] = useState({
                                                fNameValid: false,
                                                lNameValid: false,
                                                patIdValid: false,
                                                caseIdValid: false,
                                                phyValid: false,
    });
    const [workType, setWorkType] = useState(null);
    const [uploadErrorMessage, setUploadErrorMessage] = useState(null);
    const history = useHistory();

    const [appointment, setAppointment] = useState(defaultAppointment);

    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const steps = getSteps();

    PubSub.subscribe('AccountChanged', () => {
        checkCanViewUpload();
        debounceSearch(searchText)
    });

    useEffect(() => {
        if (searchText) {
            debounceSearch(searchText);
        }
    }, [searchText, toDate, fromDate])

    useEffect(() => {
        checkCanViewUpload();
        loadAvailableDictators();
    },[])

    const checkCanViewUpload = () => {
        let canViewDocumentUpload = auth.canViewDocumentUpload();
        let isCodingAccount = auth.getIsCoding();
        if (canViewDocumentUpload === 'false' || isCodingAccount === 'false') {
            history.push(`/`);
        }
    }
    const searchSchedule = (searchText) => {
        const searchRequest = {
            FromDate: fromDate.date,
            ToDate: toDate.date,
            Account: auth.getActiveAccount(),
            DictatorId: "",
            IncludeFilteredProcedures: false,
            StatusFilters: [
                "NeedsDictation",
            ]
        }
        setLoading(true);
        searchAccess.search(searchRequest)
            .then(result => {
                setSearchResult(filterResult(searchText, result));
            })
            .catch(error => { })
            .finally(() => setLoading(false));
    }
    const debounceSearch = _.debounce((value) => searchSchedule(value), 500)

    const loadAvailableDictators = () => {
        const requestedAccounts = auth.getActiveAccount();
        userDataAccess.getDictatorsByAccount(requestedAccounts).then(function (dictators) {
            setAvailableDictators(dictators);
        });
    }
    const onSearchChange = (event) => {
        const { value } = event.target;
        setSearchText(value);
    }
    const filterResult = (searchText, result) => {
        if (!searchText) return [];
        const lowerSearchText = searchText.toLowerCase();
        return result.filter(x => x.PatientFirstName.toLowerCase().includes(lowerSearchText) || x.PatientLastName.toLowerCase().includes(lowerSearchText))
    }
    const onCancelScheduleDetail = (event,reason) => {
        if (reason == 'backdropClick') return;
        debounceSearch(searchText);
        setScheduleDetailDialogSettings({ ...ScheduleDetailDialogSettings, open: false });
    }

    const onListItemClick = (patientItem) => {
        const { PatientFirstName: fNameValid,
            PatientLastName: lNameValid,
            PatientId: patIdValid,
            AppointmentId: caseIdValid,
            DictatorId: phyValid,
            DateOfBirth } = patientItem.AppointmentInfo;
        setFormValid(fNameValid && lNameValid && patIdValid && caseIdValid && phyValid);
        setFieldValid({
            fNameValid: fNameValid.length > 0,
            lNameValid: lNameValid.length > 0,
            patIdValid: patIdValid.length > 0,
            caseIdValid: caseIdValid.length > 0,
            phyValid: phyValid.length > 0
        })


        setAppointment({
            ...patientItem.AppointmentInfo,
            DateOfBirth: new Date(DateOfBirth).toJSON().slice(0, 10)
        });
    }

    const handleFromDateChange = (date) => {
        if (moment(date).isValid()) {
            setFromDate({ date: moment(date), input: moment(date).format("MM/DD/YYYY") });
        }
    }

    const handleToDateChange = (date) => {
        if (moment(date).isValid()) {
            setToDate({ date: moment(date), input: moment(date).format("MM/DD/YYYY") });
        }
    }
    const handleClear = () => {
        setAppointment(defaultAppointment);
        setFromDate(defaultFromDate);
        setToDate(defaultToDate);
        searchSchedule(null);
        setSearchText("");
    }
    const handleSnackClose = () => {
        setOpenSnack(false);
        setSnackMessage(null);
    }
    const handleSuccess = () => {
        setSnackMessage('Upload Successful');
        setOpenSnack(true);
        handleClear();
        setScheduleDetailDialogSettings({ ...ScheduleDetailDialogSettings, open: false });

    }
    const handleError = () => {
        setSnackMessage('Error Uploading');
        setOpenSnack(true);
    }

    const handleWorkTypeChange = (workType) => {
        setWorkType(workType);
    }

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const handlePatientChange = name => event => {
        let updatedAppointment = { ...appointment };
        updatedAppointment[name] = event.target.value;
        validateField(name, event.target.value);
        setAppointment(updatedAppointment);
    };

    const onSaveAppointmentInfo = async () => {
        const result = await searchAccess.saveAppointmentInfo(appointment);        
    }

    const onScheduleFileChange = file => {
        setLoading(true)
        try {
            if (validateFileType(file.type)) {
                var fileObj = {
                    fileName: "",
                    base64: "",
                    fileExt: ""
                };
                fileObj.fileName = new String(file.name);
                let lastDot = fileObj.fileName.lastIndexOf('.');
                fileObj.fileExt = fileObj.fileName.substring(lastDot + 1);
                fileToBase64(file, (err, result) => {
                    if (result) {
                        fileObj.base64 = new String(result);
                        setfileObject(fileObj);
                    }
                })
            }
            else {
                //event.target.value = '';
            }
        } catch(err) {

        } finally {
            setLoading(false);
        }
        
    }

    const fileToBase64 = (file, cb) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
            cb(null, reader.result)
        }
        reader.onerror = function (error) {
            cb(error, null)
        }
    }

    const validateFileType = () => true;

    const handleUpload = () => {
        const MAX_FILE_SIZE = 80 * 1024 * 1024; // 80MB
        const base64String = fileObject.base64.split(',')[1] || fileObject.base64;
        const base64Length = base64String.length;
        const padding = (base64String.charAt(base64Length - 2) === '=') ? 2 : ((base64String.charAt(base64Length - 1) === '=') ? 1 : 0);
        const fileSizeInBytes = 0.75 * (base64Length - padding);
        if (fileSizeInBytes > MAX_FILE_SIZE) {
            setLoading(false);
            setUploadErrorMessage('\'' + fileObject.fileName + '\' file size exceeds maximum limit. Maximum allowed file size is 80 MB');
        } else {
            setLoading(true);
            setUploadErrorMessage(null);
            FileUpload()
                .then(async (result) => {
                    handleNext();
                })
                .catch((error) => {
                    if (error && error.response) {
                        setUploadErrorMessage(error.response.data.Message);
                    }
                })
                .finally(() => {
                    setLoading(false);
                })
        }        
    };

    const FileUpload = async () => {
        const base64 = fileObject.base64.split(',', 2)[1];
        const ScheduleItem = appointment;
        const fileExt = fileObject.fileExt.toLowerCase();

        const fileFormatMap = {
            tiff: '1',
            tif: '1',
            pdf: '0',
            rtf: '4'
        };

        const fileFormat = fileFormatMap[fileExt] || '3';

        const NormalRequest = {
            Name: fileObject.fileName,
            Account: auth.getActiveAccount(),
            WorkType: workType,
            DocumentAsBase64String: base64,
            FileFormat: fileFormat
        };

        const data = { NormalRequest, ScheduleItem };        

        try {
            const rs = await searchAccess.saveDocumentToSchedule(data);
            setfileObject({ fileName: "", base64: "", fileExt: "" });
            setReportId(rs.data);

            var PatientJobData = await dataAccess.getReportDetailById(rs.data, auth.getActiveAccount());

            const resetCodingJob = {
                Id: rs.data,
                JobId: PatientJobData.JobId,
                AccountNumber: PatientJobData.Account,
                AdmitDate: ScheduleItem.DateOfService,
                WorkType: PatientJobData.Account + '[01]-' + NormalRequest.WorkType,
                PatientId: ScheduleItem.PatientId,
                CaseId: ScheduleItem.AppointmentId
            }

            const cjob = await searchAccess.resetCodingJobStatus(resetCodingJob);

            ReactGA.event({
                category: 'DocumentUploadView',
                action: 'SingleUpload',
                label: auth.getUserType()
            });

            return rs;
        } catch (err) {
            throw err;
        }
    };

    const validateField = (fieldName, value) => {
        let propUpdated ="";
        switch (fieldName) {
            case 'PatientFirstName':
                propUpdated = "fNameValid"
                break;
            case 'PatientLastName':
                propUpdated = "lNameValid";
                break;
            case 'PatientId':
                propUpdated = "patIdValid";
                break;
            case 'AppointmentId':
                propUpdated = "caseIdValid";
                break;
            case 'DictatorId':
                propUpdated = "phyValid";
                break;
            default:
                break;
        }
        let updatedAppontment = { ...fieldValid, [propUpdated]: value.length > 0 };
        const { fNameValid, lNameValid, patIdValid, caseIdValid, phyValid } = updatedAppontment;
        setFieldValid(updatedAppontment);
        setFormValid(fNameValid && lNameValid && patIdValid && caseIdValid && phyValid);
                      
    }

    const clearForm = () => {
        let currentDate = new Date();
        setAppointment({
                Id: 0,
                Account: auth.getActiveAccount(),
                AppointmentId: "",
                DateOfBirth: new Date().toJSON().slice(0, 10),
                DateOfService: new Date(currentDate.getTime() - (currentDate.getTimezoneOffset() * 60000)).toJSON().slice(0, 19),
                DictatorId: "",
                OperatingRoom: "",
                PatientFirstName: "",
                PatientId: "",
                CaseId: "",
                PatientLastName: "",
                PrimaryPhysican: "",
                PrimaryPhysicanNpi: "",
                Procedure: "",
                ProcedureId: "",
                ReferringPhysician: "",
                ReferringPhysicianNpi: "",
                Reports: []
        });
       setFormValid(false);
       setFieldValid({
            fNameValid: false,
            lNameValid: false,
            patIdValid: false,
            caseIdValid: false,
            phyValid: false
        });

    }

    const onAddAppointment = () => {
        if (!fieldValid) {
            setShowErrors(true);
        } else {
            setShowErrors(false);
        }
        setLoading(true);
        const dictator = availableDictators.find(x => x.DictatorId === appointment.DictatorId);
        if (appointment) appointment.PrimaryPhysician = dictator.Physician;
        appointment.Account = auth.getActiveAccount();
        if (!savesScheduleEntry(appointment)) {
            setLoading(false);
            handleNext();
            return;
        }
        searchAccess.saveAppointmentInfo(appointment)
        .then(function (rs) {
            handleNext();
        })
        .catch(err => { })
        .finally(setLoading(false));
    }

    const handleViewReport = (e) => {
        e.preventDefault();
        history.push(`/reportDetails/${auth.getActiveAccount()}/${reportId}`);
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12}>
                            <Paper className={classes.paperReports}>
                                <PatientSearch onPatientClick={onListItemClick} />
                            </Paper>
                        </Grid>
                        <Paper className={classes.paperReports}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    name="patientFirstName"
                                                    id="fName"
                                                    label="First Name"
                                                    className={classes.textField}
                                                    margin="normal"
                                                    required
                                                    onChange={handlePatientChange('PatientFirstName')}
                                                    value={appointment.PatientFirstName}
                                                    error={showErrors && fieldValid.fNameValid && "First Name is required"}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    id="lName"
                                                    label="Last Name"
                                                    className={classes.textField}
                                                    margin="normal"
                                                    required
                                                    onChange={handlePatientChange('PatientLastName')}
                                                    value={appointment.PatientLastName}
                                                    error={showErrors && fieldValid.lNameValid && "Last Name is required"}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    label="Patient ID"
                                                    className={classes.textField}
                                                    required
                                                    onChange={handlePatientChange('PatientId')}
                                                    value={appointment.PatientId}
                                                    margin="normal"
                                                    error={showErrors && fieldValid.patIdValid && "Patient Id is required"}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    label="Case ID"
                                                    className={classes.textField}
                                                    required
                                                    onChange={handlePatientChange('AppointmentId')}
                                                    value={appointment.AppointmentId}
                                                    margin="normal"
                                                    error={showErrors && fieldValid.caseIdValid && "Case Id is required"}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="date"
                                                    label="Date of Birth"
                                                    className={classes.textField}
                                                    value={appointment.DateOfBirth}
                                                    margin="normal"
                                                    onChange={handlePatientChange('DateOfBirth')}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    type="datetime-local"
                                                    label="Date of Service"
                                                    className={classes.textField}
                                                    value={appointment.DateOfService}
                                                    margin="normal"
                                                    onChange={handlePatientChange('DateOfService')}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="Operating Room"
                                                    className={classes.textField}
                                                    onChange={handlePatientChange('OperatingRoom')}
                                                    margin="normal"
                                                />
                                            </Grid>

                                            <FormControl className={classes.formControl} fullWidth
                                                error={showErrors && fieldValid.phyValid && "Physician is required"} required>
                                                <InputLabel htmlFor="DictatorId">Physician</InputLabel>
                                                <Select
                                                    value={appointment.DictatorId}
                                                    onChange={handlePatientChange('DictatorId')}
                                                    name="DictatorId"
                                                    displayEmpty
                                                    required


                                                >
                                                    {availableDictators.map((s,key) => {
                                                        return <MenuItem key={key} value={s.DictatorId}>{s.Name}</MenuItem>
                                                    })}

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                         </Paper>
                      </Grid>
                    )
            case 1:
                return (
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={4}>
                            <Paper className={classes.paperReports}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Please select a work (document) type from the dropdown below and then click on the arrow to upload a report
                                </Typography>
                                <Grid item xs={6}>
                                    <WorkTypeSelector
                                        account={auth.getActiveAccount()}
                                        onChange={handleWorkTypeChange}
                                    ></WorkTypeSelector>
                                </Grid>
                                <Grid item>
                                    {loading ? (
                                        <LinearProgress />
                                    ) :
                                        null
                                    }
                                </Grid>
                                <Grid item>
                                    <SingleUploader caption="Upload File" onChangeFile={onScheduleFileChange}></SingleUploader>
                                    {uploadErrorMessage ? (
                                        <Typography class={classes.errorText} variant="subtitle2" gutterBottom>
                                            {uploadErrorMessage}
                                        </Typography>) : null}
                                </Grid>
                                <Typography variant="subtitle2" gutterBottom style={{ fontStyle: 'italic', marginTop: '16px' }}>
                                    *Please ensure that each file you upload is no larger than 80 MB. If your file exceeds this limit, consider compressing it or uploading a smaller file.
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                )
            case 2: return (
                <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={4}>
                        <Paper className={classes.paperReports} justifyContent="center">
                            <Grid container direction="column">
                                <Grid item align="center">
                                    <Typography>Job Uploaded Successfully</Typography>
                                </Grid>
                                <Grid item align="center">
                                    <CheckCircleOutlineIcon style={{ fontSize: 64, color: "rgb(183, 223, 185)"}} />
                                </Grid>
                                <Grid item align="center">
                                    <Link button onClick={handleViewReport} href="#">View Report</Link>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                )
            default:
                return 'Unknown step';
        }
    }

    const onCancelAddScheduleItem = (event, reason) => {
        if (reason == 'backdropClick') return;
        
        setActiveStep(0);
        clearForm();
        setAddScheduleItemDialogSettings({ ...ScheduleDetailDialogSettings, open: false });
    }

    const handleAddScheduleItem = (account, id) => {
        setAddScheduleItemDialogSettings({ account, id, open: true });
    }


    const $el = document.querySelector('body');
    const PopperContainer = ({ children }) => (
        ReactDOM.createPortal(
            children,
            $el,
        )
    );
    return (
        <div style={{ paddingBottom: 250 }}>
            <Typography variant="h5" gutterBottom>
                Coding Upload
            </Typography>
            <Typography variant="subtitle2" gutterBottom style={{ fontStyle: 'italic' }}>
                *Op Report cannot be modified to include headers or be electronically signed.
            </Typography>
            <br />
            <Grid container>
                <Grid item xs={6}>
                    <Grid container spacing={4} direction="column" justify="center">
                        <Grid item>
                            <Typography variant="h6" gutterBottom>
                                Express Single Coding Upload
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom>
                                Upload a single document (e.g., Operative Report.) to a scheduled item or patient visit.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Card style={{minHeight: '100px'} }>
                                <CardContent>
                                    <Grid container className={classes.dateContainer} spacing={2}>
                                        <Grid item>
                                            <Button color="secondary" variant="contained" onClick={handleAddScheduleItem} startIcon={<AddCircleIcon />}>Add</Button>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardActions></CardActions>
                            </Card>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" gutterBottom>
                                Batch Coding Upload
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom>
                                Upload more than one document (e.g., Operative Report, Pathology Report, Implant Log, etc.) to be processed by our coding department.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Card>
                                <CardContent>
                                    <Upload />
                                </CardContent>
                                <CardActions>
                                </CardActions>
                            </Card>
                            <Typography variant="subtitle2" gutterBottom style={{ fontStyle: 'italic', marginTop: '16px' }}>
                                *Do not upload more than 5 files at a time. Please ensure that each file you upload is no larger than 80 MB. If your file exceeds this limit, consider compressing it or uploading a smaller file.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" gutterBottom>
                                Batch Coding Upload Status
                            </Typography>
                        </Grid>
                        <Grid item>
                            <BatchCodingUploadsTable/>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={openSnack}
                autoHideDuration={3000}
                onClose={handleSnackClose}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{snackMessage}</span>}
            />
            <Dialog onClose={onCancelScheduleDetail} open={ScheduleDetailDialogSettings.open} aria-labelledby="simple-dialog-title" fullWidth
                maxWidth="lg" PaperProps={{ xs: { width: "1200px" } }}>
                <DialogTitle id="simple-dialog-title">Upload Report</DialogTitle>
                <DialogContent>
                    <ScheduleDetails account={ScheduleDetailDialogSettings.account} patientListId={ScheduleDetailDialogSettings.id} onSuccess={handleSuccess} onError={handleError } />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancelScheduleDetail} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog onClose={onCancelAddScheduleItem} open={AddScheduleItemDialogSettings.open} aria-labelledby="simple-dialog-title" fullWidth
                maxWidth="lg" PaperProps={{ xs: { width: "1200px" } }}>
                <DialogTitle id="simple-dialog-title">Add New Patient Report</DialogTitle>
                <DialogContent>
                    <div className={classes.root}>
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                if (isStepSkipped(index)) {
                                        stepProps.completed = false;
                                }
                                        return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel {...labelProps}>{label}</StepLabel>
                                        </Step>
                                        );
                            })}
                                    </Stepper>
                                    <div>
                                        {activeStep === steps.length ? (
                                            <div>
                                                <Typography className={classes.instructions}>
                                                    All steps completed - you&apos;re finished
                                                </Typography>
                                                <Button onClick={handleReset} className={classes.button}>
                                                    Reset
                                                </Button>
                                            </div>
                                        ) : (
                                            <div>
                                                <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                                            </div>
                                        )}
                                    </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    {activeStep == 0 ? (
                        <React.Fragment>
                            <Grid item>
                                <Button variant="contained" onClick={handleClear} color="primary" disabled={loading}>Clear</Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" onClick={onAddAppointment} color="primary" disabled={!formValid || loading}>Add</Button>
                            </Grid>
                        </React.Fragment>
                    ) : null
                    }
                    {activeStep == 1 ? (
                        <Grid item>
                            <Button variant="contained" onClick={handleUpload} color="primary" disabled={loading || !workType || fileObject.fileName.length === 0}>Upload</Button>
                        </Grid>) : null
                    }
                    {activeStep === 2 ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={onCancelAddScheduleItem}
                            className={classes.button}
                        >
                            Finish
                        </Button>
                        ) : null
                    }
                    <Button onClick={onCancelAddScheduleItem} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
        )
}

export default DocumentUpload;


// WEBPACK FOOTER //
// ./src/components/DocumentUploadView.js